angular.module('aprima-core-ui').directive('apSwipeable', ['$window', '$timeout', 'Bridge', '_', 'ScrollerService', 'NgZoneService',
    function ($window, $timeout, Bridge, _, ScrollerService, NgZoneService) {
    'use strict';
    var Hammer = $window.Hammer;
    var MutationObserver = $window.MutationObserver || $window.WebKitMutationObserver || $window.MozMutationObserver;

    return {
        restrict: 'E',//could change to allow attribute as well
        scope: {
            currentPane: '=?',
            paneChanged: '&',
            //lastHeader true is for controls that have headers that are just on the right side or full screen
            useLastHeader: '&',
            scrollerId: '@',
            autoResize: '@',
            scrollDiv: '@'
        },
        transclude: true,
        template: '<div><div ap-swipeable-container ng-transclude></div></div>',
        link: link,
    };

    // This is wrapped to run outside of the Angular zone, because of all of the Hammer and MutationObserver
    // stuff it's doing, that doesn't need to happen inside of the Angular zone.
    // It should have a noticeable performance difference when inside of an UpgradeComponent.
    function link(scope, elem) {
        var result = NgZoneService.contextRun(function (zoneAwareObject) {
            return zoneAwareLink(scope, elem, zoneAwareObject);
        });
        return result;
    }

    // This zoneAwareObject always needs to be the last parameter to this function.
    function zoneAwareLink(scope, elem, zoneAwareObject) {
        scope.currentPane = scope.currentPane || 0;
        var $wrapper = elem.children().first(),
            wrapper = $wrapper.get(0),
            container = $wrapper.children().first(),
            paneCount,
            hammer = new Hammer(container.get(0)),
            initialSetup = true,
            scroller = $window,
            scrollDiv = $(scope.scrollDiv);

        //MutationObserver not supported until IE 11 and later, but Android and iOS are okay
        var observer = new MutationObserver(function(mutations) {
            var panesChanged = _.some(mutations, function(mutation) {
                return mutation.type === 'childList' && (mutation.addedNodes.length || mutation.removedNodes.length);
            });
            if(panesChanged) {
                updatePanes();
            }
        });

        //Add listeners for when Panes are added or Widths need to be resized
        observer.observe(container.get(0), { childList: true });

        scope.$evalAsync(function () {
            //the easyScroller won't be accessible in the dom until this point
            scroller = ScrollerService.getScroller(scope.scrollerId) || $window;
        });

        //Update the size of the container and
        //potentially show a different pane as well when the number of panes changes
        function updatePanes () {
            var panes = getPanes();
            if(panes && panes.length) {
                var newPane = scope.currentPane >= panes.length ? panes.length - 1 : scope.currentPane;
                setup(panes, newPane);
            }
        }

        var eventsEnabled;
        var enableEventsOnce = _.once(function () {
            hammer.on('panend panleft panright swipeleft swiperight', handleHammer);

            if(scrollDiv && scrollDiv.length === 1){
                hammer.on('panup pandown', handleHammer);
            }

            eventsEnabled = true;
        });

        function setup(panes, index) {
            paneCount = panes.length;
            if(paneCount) {
                panes.width((1/paneCount)*100 + '%');
                container.width(100 * paneCount + '%');
            }

            showPane(index);

            enableEventsOnce();
            initialSetup = false;
        }

        function getPanes() {
            return container.children();
        }

        function showPane(index, animate) {
            var changingPane = index !== scope.currentPane;

            // these hammer events are outside of angular so we need to $apply() scope changes
            // update the currentPane first with $apply
            zoneAwareObject.runInZoneIfNecessary(function() {
                scope.$apply(function () {
                    scope.currentPane = index;
                });
            });

            var offset = -((100/paneCount)*scope.currentPane);
            updateContainer(offset, animate);

            if(scope.autoResize){
                var panes = getPanes();

                // TODO make sure current pane in panes
                if(panes && panes.length > 0){
                    var currentPane = panes[scope.currentPane];
                    var targetHeight = $(currentPane).height();

                    $wrapper.height(targetHeight);
                }
            }

            if(changingPane || initialSetup) {
                //if easyScroller is already scrolling,
                //then using true for animate in scrollTo, will cause easyScroller to not scroll at all
                if(!scope.scrollDiv){
                    scroller.scrollTo(0, 0, false);
                }
                Bridge.updatePageIndicator(paneCount, scope.currentPane, scope.useLastHeader());

                // these hammer events are outside of angular so we need to $apply() scope changes
                // then $apply the change function for currentPane after currentPane
                // was $apply-ed so that it is already updated in parent scope
                zoneAwareObject.runInZoneIfNecessary(function() {
                    scope.$apply(function () {
                        scope.paneChanged({
                            pane: scope.currentPane,
                            adjacentPanes: getAdjacentPanes(scope.currentPane)
                        });
                    });
                });
            }
        }

        function updateContainer(percent, animate) {
            container.removeClass('animate');

            if (animate) {
                container.addClass('animate');
            }
            container.css('webkit-transform', 'translate3d(' + percent + '%,0,0)');
            container.css('transform', 'translate3d(' + percent + '%,0,0)');
            container.css('moz-transform', 'translate3d(' + percent + '%,0,0)');
        }

        function getAdjacentPanes(index) {
            var adjacentPanes = [];
            var next = index + 1,
                prev = index - 1;
            if(prev >= 0) {
                adjacentPanes.push(prev);
            }
            if(next <= paneCount - 1) {
                adjacentPanes.push(next);
            }
            return adjacentPanes;
        }

        function next() {
            var newPane = scope.currentPane + 1;
            return showPane(newPane < paneCount ? newPane : paneCount-1, true);
        }

        function prev() {
            var newPane = scope.currentPane - 1;
            return showPane(newPane >= 0 ? newPane : 0, true);
        }

        var scrollStart = 0;
        function handleHammer(ev) {
            // disable browser scrolling
            ev.preventDefault();

            switch (ev.type) {
                case 'panright':
                case 'panleft':
                    // keep the offset attached to the pan location
                    var paneOffset = -(100/paneCount)*scope.currentPane;
                    var dragOffset = ((100/wrapper.clientWidth)*ev.deltaX) / paneCount;

                    // slow down at the first and last pane
                    if((scope.currentPane === 0 && ev.direction === Hammer.DIRECTION_RIGHT) ||
                        (scope.currentPane === paneCount-1 && ev.direction === Hammer.DIRECTION_LEFT)) {
                        dragOffset *= 0.4;
                    }

                    updateContainer(dragOffset + paneOffset);

                    if(scope.autoResize){
                        var panes = getPanes();
                        //default to the current height;
                        var targetHeight = $(panes[scope.currentPane]).height();
                        var nextPaneHeight;

                        if(scope.currentPane !== 0 && ev.direction === Hammer.DIRECTION_RIGHT){
                            nextPaneHeight = $(panes[scope.currentPane - 1]).height();
                        }
                        else if(scope.currentPane !== paneCount -1 && ev.direction === Hammer.DIRECTION_LEFT){
                            nextPaneHeight = $(panes[scope.currentPane + 1]).height();
                        }

                        if(nextPaneHeight){
                            var heightDifference = nextPaneHeight - targetHeight;
                            targetHeight = targetHeight + (heightDifference * Math.abs(ev.deltaX)/wrapper.clientWidth);
                        }

                        $wrapper.height(targetHeight);
                    }

                    break;
                case 'panup':
                case 'pandown':
                    if(scrollDiv && scrollDiv.length === 1 && ev.deltaY){
                        if(!scrollStart){
                            scrollStart = scrollDiv[0].scrollTop;
                        }

                        scrollDiv[0].scrollTop = Math.max(0, scrollStart - ev.deltaY);
                    }

                    break;
                case 'swipeleft':
                    next();

                    // stop hammer recognizer so that way it won't trigger a panend as well
                    // which would change the pane again
                    // causing it to potentially jump 2 panes at a time
                    // ('swipeleft' and 'panend' could cause .next() to
                    // be called twice in the same session)
                    hammer.stop(true);
                    break;
                case 'swiperight':
                    prev();

                    // stop hammer recognizer so that way it won't trigger a panend as well
                    // which would change the pane again
                    // causing it to potentially jump 2 panes at a time
                    // ('swiperight' and 'panend' could cause .prev() to
                    // be called twice in the same session)
                    hammer.stop(true);
                    break;
                case 'panend':
                    // more than half the pane panned over, then navigate
                    if (Math.abs(ev.deltaX) > wrapper.clientWidth / 2) {
                        // if deltaX is >= 0 then the pan was to the right
                        if(ev.deltaX >= 0) {
                            prev();
                        }
                        else {
                            next();
                        }
                    }
                    else {
                        showPane(scope.currentPane, true);
                    }
                    scrollStart = null;
                    break;
            }
        }

        scope.$on('$destroy', function () {
            console.log('swipeable destroy');
            if(eventsEnabled){
                hammer.off('panend panleft panright swipeleft swiperight', handleHammer);
            }

            // Destroy hammer instance as well to prevent a memory leak from it holding onto a detached node.
            // Angular had this issue previously, and was updated to call .destroy() on the instance.
            // ref: https://github.com/angular/angular/issues/22155
            hammer.destroy();

            console.log('hammer dispose done');
            observer.disconnect();
        });
    }
}]);